import type { Novidade } from './tipos';

/** Fase 2, W13 (novidade na W17): módulo Relatórios no menu Financeiro, com exportação e o consolidado do grupo. */
export const novidadeRelatorios: Novidade = {
  id: '2026-10-05-relatorios',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'relatorios',
  permissao: 'relatorios.ver',
  rota: '/relatorios/relatorios/dre',
  textos: {
    pt: {
      titulo: 'Relatórios no menu Financeiro',
      resumo: 'Inadimplência, DRE, fluxo de caixa, extrato, centros de custo, parceiros e MRR, com filtros e exportação.',
      passos: [
        'Em Financeiro, Relatórios, cada aba é um relatório: escolha o período, a empresa e os filtros no topo.',
        'A DRE sai por competência ou por caixa, com as linhas pelo grupo da DRE de cada categoria.',
        'Quem vê o consolidado escolhe se as operações entre empresas do grupo ficam separadas ou eliminadas.',
        'Exportar gera o CSV completo do relatório; o arquivo fica na aba Exportações, só para quem pediu.',
      ],
    },
    en: {
      titulo: 'Reports in the Finance menu',
      resumo: 'Overdue, income statement, cash flow, statement, cost centers, partners and MRR, with filters and export.',
      passos: [
        'In Finance, Reports, each tab is a report: choose the period, the company and the filters at the top.',
        'The income statement comes on accrual or cash basis, with the lines from the income statement group of each category.',
        'Whoever sees the consolidated view chooses whether operations between group companies stay separate or are eliminated.',
        'Export creates the full CSV of the report; the file stays in the Exports tab, only for whoever asked for it.',
      ],
    },
    es: {
      titulo: 'Informes en el menú Finanzas',
      resumo: 'Morosidad, estado de resultados, flujo de caja, extracto, centros de costo, socios y MRR, con filtros y exportación.',
      passos: [
        'En Finanzas, Informes, cada pestaña es un informe: elige el período, la empresa y los filtros arriba.',
        'El estado de resultados sale por competencia o por caja, con las líneas por el grupo de cada categoría.',
        'Quien ve el consolidado elige si las operaciones entre empresas del grupo quedan separadas o eliminadas.',
        'Exportar genera el CSV completo del informe; el archivo queda en la pestaña Exportaciones, solo para quien lo pidió.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-relatorios/dre.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
